import BottomSheet from './BottomSheet';
import ThreadPanel from './ThreadPanel';
import type { ThreadComment } from '@/api/comments';
import { useTranslation } from '@/utils/i18n';

/**
 * reco-sheet-per-gesture — the circle's conversation on a reco, opened by the
 * 💬 CTA, alone.
 *
 * The legend has ONE source here: the thread itself, whose first message it is
 * (`listComments` serves `group = <circle> OR group IS NULL`). The former sheet
 * also printed it above the thread, hence the duplicate. No legend block, no
 * reactions: each lives in the sheet of its own gesture.
 */
export default function DiscussionSheet({
  open,
  thread,
  canReply,
  onSend,
  onClose,
}: {
  open: boolean;
  thread: ThreadComment[];
  /** False on a public reco: the server refuses a reply (403). */
  canReply: boolean;
  onSend?: (content: string) => Promise<void>;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <BottomSheet
      open={open}
      title={t('sheet.discussion')}
      onClose={onClose}
      testid="discussion-sheet"
    >
      <ThreadPanel thread={thread} canReply={canReply} onSend={onSend} label={(key) => t(key)} />
    </BottomSheet>
  );
}
